/**
 * This class is made to put all the configuration needed in Azure API.
 */
import {Headers} from '@angular/http';
import {environment} from '../../../environments/environment';

export class UvmApi {
  private static instance: UvmApi;
  url: string;
  headers: Headers;

  constructor() {
    this.url = environment.adminApiUrl;
    this.headers = new Headers();
    this.headers.append('Ocp-Apim-Subscription-Key', environment.ocpKey);
  }

  public static get Singleton() {
    return this.instance || (this.instance = new this());
  }
}
